module.exports = __webpack_public_path__ + "img/mini-026.dbd37a98.jpg";